import { ChartScales } from "@components/Charts/CleanChart.control";
import { ALGOS_E, isAlgo } from "@constants/Algos";
import {
  getUtcFormat,
  getUtcToday,
  getUtcTomorrow,
} from "@utils/moscowTime";
import moment, { Moment } from "moment-timezone";
import { PostRequest } from "../BaseRequest";
import { DatePeriod } from "../dto";
import { MinerHashParams } from "./dto";

// function createDatePeriodParams(
//   dateFrom: Moment | null,
//   dateTo: Moment | null
// ): DatePeriod { // ??
//   return {
//     date_from: dateFrom ? toServerDate(dateFrom) : getServerYesterday(),
//     date_to: dateTo ? toServerDate(dateTo) : getServerToday(),
//   };
// }

function createDatePeriodParamsEx(
  dateFrom: Moment | null,
  dateTo: Moment | null
): DatePeriod {
  return {
    date_from: dateFrom ? getUtcFormat(dateFrom) : getUtcToday(), //getServerToday(),
    date_to: dateTo ? getUtcFormat(dateTo) : getUtcTomorrow(),
  };
}

export class GetAdminStatisticByLocation2 extends PostRequest {
  constructor(
    dateFrom: Moment | null,
    dateTo: Moment | null,
    locationId: string
  ) {
    const params = {
      ...createDatePeriodParamsEx(dateFrom, dateTo),
      location_id: locationId
    };
    super("/admin/miner/statistic3", params);
  }
}

// export class GetAdminStatisticByObject2 extends PostRequest {
//   constructor(
//     dateFrom: Moment | null,
//     dateTo: Moment | null,
//     id: string
//   ) {
//     const params = {
//       ...createDatePeriodParamsEx(dateFrom, dateTo),
//       object_id: id
//     };
//     super("/admin/miner/statistic3", params);
//   }
// }

export class GetUserStatisticByLocation2 extends PostRequest {
  constructor(
    dateFrom: Moment | null,
    dateTo: Moment | null,
    locationId: string
  ) {
    const params = {
      ...createDatePeriodParamsEx(dateFrom, dateTo),
      location_id: locationId
    };
    super("/user/miner/statistic3", params);
  }
}

// export class GetUserStatisticByObject2 extends PostRequest {
//   constructor(
//     dateFrom: Moment | null,
//     dateTo: Moment | null,
//     id: string
//   ) {
//     const params = {
//       ...createDatePeriodParamsEx(dateFrom, dateTo),
//       object_id: id
//     };
//     super("/user/miner/statistic3", params);
//   }
// }

export class GetAdminSummaryHashStatistic2 extends PostRequest {
  constructor(
    dateFrom: Moment | null,
    dateTo: Moment | null,
    onlyAdmin?: boolean,
    onlyUsers?: boolean,
    poolOrHash?: ALGOS_E | string | number,
    userId?: string,
  ) {
    const params: MinerHashParams = {
      ...createDatePeriodParamsEx(dateFrom, dateTo),
    };
    if (poolOrHash) {
      if (isAlgo(poolOrHash)) {
        params.hash = poolOrHash;
      } else {
        params.pool_id = poolOrHash;
      }
      params.only_admin = onlyAdmin;
      params.only_users = onlyUsers;
    }
    if (userId) {
      params.user_id = userId;
    }
    super("/admin/miner/statistic3", params);
  }
}


export class GetUserSummaryHashStatistic2 extends PostRequest {
  constructor(
    dateFrom: Moment | null,
    dateTo: Moment | null,
    poolOrHash: ALGOS_E | string | number
  ) {
    const params: MinerHashParams = {
      ...createDatePeriodParamsEx(dateFrom, dateTo),
    };
    if (isAlgo(poolOrHash)) {
      params.hash = poolOrHash;
    } else {
      params.pool_id = poolOrHash;
    }
    super("/user/miner/statistic3", params);
  }
}

export class PostMinerChatMessage extends PostRequest {
  constructor(isAdmin: boolean, text: string, minerId: string) {
    const params = {
      text,
      id: minerId,
    };
    super(isAdmin ? "/admin/miner/chat/add" : "/user/miner/chat/add", params);
  }
}


//// new
export class GetAdminMinerHashStatistic2 extends PostRequest {
  constructor(
    dateFrom: Moment | null,
    dateTo: Moment | null,
    scale: ChartScales | null,
    minerId: number,
  ) {
    const params: MinerHashParams = {
      ...createDatePeriodParamsEx(dateFrom, dateTo),
      miner: minerId,
      scale: scale || undefined,
    };
    super("/admin/miner/statistic3", params);
  }
}

export class GetUserMinerHashStatistic2 extends PostRequest {
  constructor(
    dateFrom: Moment | null,
    dateTo: Moment | null,
    scale: ChartScales | null,
    minerId: number
  ) {
    const params: MinerHashParams = {
      ...createDatePeriodParamsEx(dateFrom, dateTo),
      miner: minerId,
      scale: scale || undefined,
    };
    super("/user/miner/statistic3", params);
  }
}

export class GetAdminHashrateStatistic2 extends PostRequest {
  constructor(
    dateFrom: Moment | null,
    dateTo: Moment | null,
    userId: string,
    onlyAdmin?: boolean,
    onlyUsers?: boolean,
  ) {
    const params: MinerHashParams = {
      ...createDatePeriodParamsEx(dateFrom, dateTo),
      user_id: userId,
      only_admin: onlyAdmin,
      only_users: onlyUsers,

    };
    super("/admin/miner/statistic3", params);
  }
}

export class GetUserHashrateStatistic2 extends PostRequest {
  constructor(
    dateFrom: Moment | null,
    dateTo: Moment | null,
    userId: string
  ) {
    const params: MinerHashParams = {
      ...createDatePeriodParamsEx(dateFrom, dateTo),
      user_id: userId,
    };
    super("/user/miner/statistic3", params);
  }
}